export const PRODUCT_CARD_EVENTS = [
    'PRODUCT_CARD_CREATED',
    'PRODUCT_CARD_VERSION_CREATED',
    'PRODUCT_CARD_DECLARATION_SIGNED',
    'PRODUCT_CARD_UPDATED',
    'PRODUCT_CARD_SUBMITTED',
    'PRODUCT_CARD_WITHDRAWN',
    'PRODUCT_CARD_REJECTED',
    'PRODUCT_CARD_PUBLISHED',
    'PRODUCT_CARD_BLOCKED',
    'PRODUCT_CARD_UNBLOCKED',
    'PRODUCT_CARD_DELETED',
    'PRODUCT_CARD_BULK_UPLOAD_COMPLETED',
] as const;

export type ProductCardAuditEventType = typeof PRODUCT_CARD_EVENTS[number];

export interface ProductCardAuditEntry {
    eventId: string;
    eventType: ProductCardAuditEventType;
    eventTimestamp: string;
    userId?: string;
    userFullName?: string;
    userRole?: string;
    clientId?: number;
    organizationId?: number;
    organizationName?: string;
    organizationTin?: string;
    ipAddress?: string;
    userAgent?: string;
    cardOrganizationId?: number;
    cardOrganizationName?: string;
    productId?: string;
    productCode?: string;
    productType?: string;
    productVersion?: number;
    productStatus?: string;
    changedFields?: Array<{field: string; oldValue?: string; newValue?: string}>;
    rejectionReason?: string;
    previousVersionId?: string;
    declarationId?: string;
    declarationType?: string;
    declarationVersion?: string;
    signedAt?: string;
    declarationHash?: string;
    declarationPdfHash?: string;
    fileName?: string;
    createdCount?: number;
    failedCount?: number;
    loadTaskId?: string;
    loadStatus?: 'PENDING' | 'PROCESSING' | 'SUCCESS' | 'FAILED';
}

export interface ProductCardAuditPage {
    data: ProductCardAuditEntry[];
    page: number;
    size: number;
    totalPages: number;
    totalElements: number;
}

export interface ProductCardAuditParams {
    eventId?: string;
    userRole?: string;
    search?: string;
    sortDesc?: boolean;
    userId?: string;
    userFullName?: string;
    organizationId?: number;
    organizationName?: string;
    organizationTin?: string;
    eventType?: string;
    from?: string;
    to?: string;
    productId?: string;
    productCode?: string;
    productVersion?: number;
    productStatus?: string;
    page?: number;
    size?: number;
}
